import React from 'react'
import Datagrid from '../../Component/Table/Dbm'

export default (props) => <Datagrid/>





// WEBPACK FOOTER //
// ./app/App/Module/Gestion/Page/Dbm/index.js